import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    height: 80,
    background: "#fff",
    paddingLeft: 46,
    paddingRight: 33,
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #dfe7ef",
    boxShadow: "0 8px 26px rgba(18, 38, 63, 0.06)",
    color: "#102033",
  },
  editIcon: {
    display: "flex",
    justifyContent: "center",
    borderRadius: 12,
    padding: 0,
    alignItems: "center",
    background: "#fff",
    marginRight: 14,
    "& .MuiSvgIcon-root": {
      color: "#007a4f",
      cursor: "pointer",
      fontSize: 21,
    },
  },
  dispatcherbutton: {
    minHeight: "48px !important",
    padding: "0 20px !important",
    background: "#fff !important",
    border: "1px solid #d8e3ed !important",
    borderRadius: "12px !important",
    boxShadow: "0 5px 14px rgba(18, 38, 63, 0.07) !important",
    color: "#007a4f !important",
    fontSize: "14px !important",
    fontWeight: "800 !important",
    textTransform: "none !important",
    "&:hover": {
      background: "#f7fbff !important",
    },
  },
  headerleftwrap: {
    display: "flex",
    alignItems: "center",
  },
  headerrightwrap: {
    display: "flex",
    justifyContent: "right",
    alignItems: "center",
    gap: 18,
  },
  welcomeContiner: {
    display: "flex",
    alignItems: "center",
    zIndex: 999,
  },
  logo: {
    width: 60,
    height: 60,
    objectFit: "cover",
    cursor: "pointer",
  },
  headernav: {},
  avatarContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 12,
    color: "#0f2137",
    "& .MuiAvatar-root": {
      border: "1px solid #dfe7ef",
      boxShadow: "0 6px 14px rgba(18, 38, 63, 0.08)",
      background: "#f6f9fc",
      color: "#102033",
    },
    "& .MuiSvgIcon-root": {
      color: "#0f2137",
      fontSize: 22,
    },
  },
  headerUserInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    lineHeight: 1.1,
    minWidth: 0,
  },
  headerUserName: {
    "&.MuiTypography-root": {
      fontSize: 13,
      fontWeight: 800,
      color: "#102033",
      whiteSpace: "nowrap",
      maxWidth: 180,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  headerUserSub: {
    "&.MuiTypography-root": {
      fontSize: 11,
      fontWeight: 600,
      color: "#607086",
      whiteSpace: "nowrap",
      maxWidth: 180,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  bellnotification: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  menu: {
    top: "10px !important",
    "& .MuiMenu-list": {
      paddingTop: 8,
      paddingBottom: 8,
      background: "#fff",
      border: "1px solid #e2ebe1",
      boxShadow: "0 20px 60px rgba(22, 42, 31, 0.14)",
      minWidth: 190,
    },
    "& .MuiButtonBase-root": {
      paddingRight: 24,
      color: "#566773",
      fontSize: 12,
      "&:hover": {
        background: "#f1f7ee",
        color: "#0b6d1f",
      },
    },
  },
  menuItem: {
    gap: 10,
    minHeight: 38,
    "& .MuiSvgIcon-root": {
      color: "inherit",
    },
  },
  menuLabels: {
    paddingInline: 4,
    dispay: "flex",
    gap: 8,
    alignItems: "center",
    "&.MuiTypography-root": {
      fontSize: 12,
      fontWeight: 500,
    },
  },
}));

export default useStyles;
